import { Link } from '@solidjs/meta';

export function Imbue()
{

	return (<>
<Link rel='preconnect' href='https://fonts.googleapis.com'/>
<Link rel='preconnect' href='https://fonts.gstatic.com' crossorigin=''/>
<Link href='https://fonts.googleapis.com/css2?family=Imbue:opsz,wght@10..100,100..900&display=swap' rel='stylesheet'/>
	</>);



}

Imbue.fontFamily = '"Imbue", serif';
